export default "__VITE_ASSET__CoKLCvrJ__"